// CANONICAL COPY (GH #7115). src/constants/obligations/obl-lawful-basis.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-lawful-basis',
  title: 'Verify lawful basis for each processing activity',
  description:
    "Confirm that every personal data processing activity under the controller's responsibility has a documented lawful basis under GDPR Article 6 — and, for special categories of data, an additional condition under Article 9. The lawful basis shall be identified before processing begins, recorded in the records of processing activities, and communicated to data subjects through transparency notices. Review the lawful basis register covering purpose, data categories, legal ground selected and — where legitimate interests are relied upon — the balancing assessment.",
  category: 'compliance',
  scfIds: ['SCF-PRV-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'ropa-lawful-basis-complete',
      description:
        'All active processing activities in the RoPA register have a documented lawful basis',
    },
    { type: 'document-published', description: 'Lawful basis register / procedure is published' },
    { type: 'document-approved', description: 'Register has been approved' },
    { type: 'document-within-sla', description: 'Register review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
